var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppvizerLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 328 70.6",
    style: {
      enableBackground: "new 0 0 328 70.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.2,12.4c3.4,0.2,6.2-2.4,6.4-5.8c0-0.1,0-0.3,0-0.4c0-3.5-2.9-6.4-6.4-6.4c-3.5,0-6.4,2.9-6.4,6.4 c0,3.4,2.6,6.1,6,6.2C198,12.4,198.1,12.4,198.2,12.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.2,16.5v10.1c-1.4-6.8-6.9-11.1-14.1-11.1C6.6,15.5,0,22.8,0,34.5s6.6,19,16.1,19c3.6,0.1,7.2-1.2,9.9-3.6 v-3.4c-1.3,1.2-2.9,1.9-4.7,1.9c-5.2,0-8.6-6-8.6-13.9s3.5-13.8,8.6-13.8s8.8,5.7,8.8,13.6v8.2l0,0v10.1h12V16.5H30.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.9,15.5c-7.2,0-12.6,4.2-14.1,11V16.5H52.9v54.1l11.9-0.1V42.5l0,0v-8.2c0-8,3.7-13.6,8.8-13.6 s8.6,6,8.6,13.9s-3.4,13.8-8.6,13.8c-1.7,0-3.4-0.7-4.6-1.9V50c2.7,2.4,6.3,3.7,9.9,3.6c9.5,0,16.1-7.3,16.1-19 S88.4,15.5,78.9,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.9,15.5c-7.2,0-12.6,4.2-14.1,11V16.5h-11.9v54.1l11.9-0.1V42.5l0,0v-8.2c0-8,3.7-13.6,8.8-13.6 s8.6,6,8.6,13.9s-3.4,13.8-8.6,13.8c-1.7,0-3.4-0.7-4.6-1.9V50c2.7,2.4,6.3,3.7,9.9,3.6c9.5,0,16.1-7.3,16.1-19 S139.4,15.5,129.9,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M277.4,47.2c-7.6,0-12.4-6.1-12.9-12.6v-2.3c0.1-11.1,2.5-15.6,7.4-15.6s6.8,3.3,6.9,15.6h-10.1v2.3h21.7 c0-11.8-7.4-19.1-18.5-19.1s-20.3,7.7-20.3,19s9.1,19.1,20.5,19.1c8.5,0,14.8-4.7,17.7-13l-1.1-0.4C285.8,45.3,282,47.2,277.4,47.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M325.8,15.8c-2.5,0-5,0.5-7.2,1.4c-2.2,0.9-4.2,2.2-5.9,3.9c-0.1,0.1-0.3,0.3-0.4,0.4v-5.1h-12v36.1h12V33.4 c0-1.7,0.3-3.4,1-5c0.7-1.6,1.6-3.1,2.8-4.3c1.2-1.3,2.7-2.3,4.3-3c1.7-0.8,3.5-1.1,5.4-1.1h2.2v-4.2H325.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "178.2,39.1 188.5,16.5 185.9,16.5 176.9,36.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "174.4,40.7 174.4,40.7 162,16.5 147.8,16.5 167.1,52.6 172.2,52.6 176.1,44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "239,31.3 246.9,18.7 246.9,16.5 213.5,16.5 213.5,18.7 232.9,18.7 213,50.4 213,52.6 225.5,52.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "231.8,50.4 230.4,52.6 247,52.6 247,50.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192.3,16.5v2.3h9.2v1c-5.8,6.5-9.2,13.8-9.2,22.5v10.4h12V16.5H192.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppvizerLogoWhite);
export default __webpack_public_path__ + "static/media/appvizer-logo-white.f795c3a731e40fcf70684fea16e0a8ff.svg";
export { ForwardRef as ReactComponent };